import { z } from 'zod';

export type DetachedWindowMode =
  | { type: 'main' }
  | { type: 'tab'; tabId: string }
  | { type: 'copilot' };

const DetachedSearchParamsSchema = z.object({
  detachedTab: z.string().min(1).optional(),
  detachedPanel: z.literal('copilot').optional(),
});

export function parseDetachedSearchParams(search: string): DetachedWindowMode {
  const params = new URLSearchParams(search);
  const parsed = DetachedSearchParamsSchema.safeParse({
    detachedTab: params.get('detachedTab') ?? undefined,
    detachedPanel: params.get('detachedPanel') ?? undefined,
  });

  if (!parsed.success) {
    return { type: 'main' };
  }

  if (parsed.data.detachedTab) {
    return { type: 'tab', tabId: parsed.data.detachedTab };
  }

  if (parsed.data.detachedPanel === 'copilot') {
    return { type: 'copilot' };
  }

  return { type: 'main' };
}

export function getDetachedWindowMode(): DetachedWindowMode {
  if (typeof window === 'undefined') {
    return { type: 'main' };
  }

  return parseDetachedSearchParams(window.location.search);
}

export function isDetachedWindow(): boolean {
  const mode = getDetachedWindowMode();
  return mode.type !== 'main';
}
